import React from 'react';
import PageHeader from './industrial/PageHeader';
import SEO from './SEO';
import { ProductVariant, ServiceSpec, ServiceFeature } from '../data/servicesData';
import { SpecificationsLegacy, SpecificationsTabs } from './specifications';

interface ServicePageProps {
  title: string;
  subtitle: string;
  description: string;
  mainImage: string;
  mainImageAlt?: string;
  bannerImages?: string[];
  bannerImagesAlt?: string[];
  features: ServiceFeature[];
  specifications: ServiceSpec[];
  pricing?: {
    basePrice: string;
    priceDescription: string;
    additionalInfo: string;
  };
  gallery?: string[];
  galleryAlt?: string[];
  benefits: string[];
  applications: string[];
  seoTitle?: string;
  seoDescription?: string;
  seoKeywords?: string;
  seoUrl?: string;
  structuredData?: any;
  // New: Support for product variants
  hasVariants?: boolean;
  variants?: ProductVariant[];
}

const ServicePage: React.FC<ServicePageProps> = ({
  title,
  subtitle,
  description,
  mainImage,
  mainImageAlt,
  bannerImages,
  bannerImagesAlt,
  features,
  specifications,
  pricing,
  gallery = [],
  galleryAlt = [],
  benefits,
  applications,
  seoTitle,
  seoDescription,
  seoKeywords,
  seoUrl,
  structuredData,
  hasVariants,
  variants
}) => {
  // Determine which images to use for the banner
  const displayBannerImages = bannerImages && bannerImages.length > 0
    ? bannerImages
    : [mainImage];

  // Determine whether to show variants or legacy specifications
  const showVariants = hasVariants && variants && variants.length > 0;

  return (
    <div className="service-page-industrial">
      {seoTitle && (
        <SEO
          title={seoTitle}
          description={seoDescription || description}
          keywords={seoKeywords || ''}
          url={seoUrl || ''}
          image={mainImage}
          structuredData={structuredData}
        />
      )}
      {/* Hero Section */}
      <PageHeader
        badge="SERVICIO PROFESIONAL"
        title={title}
        subtitle={`${subtitle}. ${description}`}
        buttonsAlign="left"
        paddingY="small"
        bannerImages={displayBannerImages}
        imageAlt={mainImageAlt || title}
        bannerImagesAlt={bannerImagesAlt}
        buttons={[
          {
            label: 'COTIZAR AHORA',
            href: '#cotizar',
            type: 'primary',
            icon: '📞'
          },
          {
            label: 'VER DETALLES',
            href: '#especificaciones',
            type: 'ghost',
            icon: '📋'
          }
        ]}
      />

      {/* Specifications Section */}
      {(showVariants || specifications.length > 0 || gallery.length > 0) && (
        <section className="service-specifications-industrial" id="especificaciones">
          <div className="service-container">
            <h2 className="section-title-industrial">
              {specifications.length > 0 ? 'Especificaciones Técnicas' : 'Galería'}
            </h2>

            {showVariants ? (
              <SpecificationsTabs variants={variants!} />
            ) : (
              <SpecificationsLegacy
                specifications={specifications}
                gallery={gallery}
              />
            )}
          </div>
        </section>
      )}



      {/* Related Services */}
      <section className="service-related-industrial">
        <div className="service-container">
          <h2 className="section-title-industrial">Servicios Relacionados</h2>
          <div className="related-services-grid">
            <div className="related-service-card">
              <h4>Servicio de Operarios</h4>
              <p>Personal especializado para el mantenimiento</p>
              <a href="/servicios/servicio-de-operarios" className="related-link">Ver más →</a>
            </div>
            <div className="related-service-card">
              <h4>Puntos Ecológicos</h4>
              <p>Soluciones sostenibles para tu evento</p>
              <a href="/servicios/puntos-ecologicos" className="related-link">Ver más →</a>
            </div>
            <div className="related-service-card">
              <h4>Lavamanos Portátiles</h4>
              <p>Higiene completa para tus usuarios</p>
              <a href="/servicios/lavamanos-aquastand-aquapop" className="related-link">Ver más →</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicePage;